import * as React from 'react'

function SvgBodyIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="m16.427 17.573 1.427-1.427a.5.5 0 0 1 .353-.146H20.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3.896a.25.25 0 0 1-.177-.427ZM22 16.5v1a.5.5 0 0 0 .5.5h5.896a.25.25 0 0 0 .177-.427l-1.427-1.427a.5.5 0 0 0-.353-.146H22.5a.5.5 0 0 0-.5.5Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.414 14.172A4 4 0 0 1 18.243 13h8.514a4 4 0 0 1 2.829 1.172l1.242 1.242A4 4 0 0 1 32 18.243v4.139a2 2 0 0 1-1.106 1.789l-.877.439A1.394 1.394 0 0 1 28 23.363C28 22.61 27.39 22 26.637 22H26.5a1.5 1.5 0 0 0-1.5 1.5v.071c0 .79-.64 1.429-1.429 1.429H17.43c-.79 0-1.429-.64-1.429-1.429V23.5a1.5 1.5 0 0 0-1.5-1.5h-.063c-.794 0-1.437.643-1.437 1.437 0 .96-.94 1.637-1.85 1.333l-1.782-.593A2 2 0 0 1 8 22.279v-1.82a4 4 0 0 1 3.216-3.922l1.697-.34a2 2 0 0 0 1.022-.546l1.48-1.48Zm2.829.828a2 2 0 0 0-1.415.586l-1.479 1.479a4 4 0 0 1-2.044 1.094l-1.697.34A2 2 0 0 0 10 20.458v1.82l1.092.364A3.438 3.438 0 0 1 14.437 20h.063a3.501 3.501 0 0 1 3.465 3h5.07a3.501 3.501 0 0 1 3.465-3h.137a3.364 3.364 0 0 1 3.236 2.445l.127-.063v-4.14a2 2 0 0 0-.586-1.414l-1.242-1.242A2 2 0 0 0 26.757 15h-8.514Z"
        fill="#000"
      />
      <path
        d="M16 25.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM26.5 27a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgBodyIcon
